import { render, staticRenderFns } from "./BuquesPuerto.vue?vue&type=template&id=341298ca&"
import script from "./BuquesPuerto.vue?vue&type=script&lang=js&"
export * from "./BuquesPuerto.vue?vue&type=script&lang=js&"
import style0 from "./BuquesPuerto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports